import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Icon } from 'panamera-react-ui';
var css = {
  "arrow": "oalp-3ZjXZ",
  "arrowRight": "oalp-3K6jW",
  "arrowLeft": "oalp-ym1Rw",
  "disable": "oalp-3ttb-"
};
import classNames from 'classnames';
export var SliderArrow = function SliderArrow(_ref) {
  var _classNames;
  var onClick = _ref.onClick,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? '' : _ref$iconName,
    size = _ref.size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _a;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: classNames(css.arrow, className, (_classNames = {}, _defineProperty(_classNames, css[iconName], css[iconName]), _defineProperty(_classNames, css.disable, !!((_a = className === null || className === void 0 ? void 0 : className.includes) === null || _a === void 0 ? void 0 : _a.call(className, 'slick-disabled'))), _classNames)),
    "data-aut-id": "slider-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: iconName,
    size: size
  }));
};
export default SliderArrow;